<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M891 1249 c-59 -18 -115 -64 -145 -119 -49 -90 -37 -191 32 -279 16
-20 18 -29 9 -57 -13 -42 -5 -51 30 -34 16 8 66 14 118 15 105 1 152 20 207
85 128 149 31 381 -166 396 -28 2 -66 -1 -85 -7z m170 -36 c35 -19 64 -43 84
-71 27 -40 30 -51 30 -127 0 -77 -2 -86 -31 -127 -19 -27 -50 -53 -85 -71 -47
-24 -63 -28 -129 -25 -41 1 -87 -1 -102 -6 -26 -8 -27 -7 -18 22 7 25 4 34
-12 49 -11 10 -28 34 -38 53 -48 93 -33 188 39 260 76 75 167 90 262 43z"
      />
      <path
        d="M917 1144 c-4 -4 -7 -22 -7 -41 0 -32 -1 -33 -40 -33 -29 0 -42 -5
-50 -19 -26 -49 0 -91 56 -91 33 0 34 -1 34 -41 l0 -40 48 3 c47 3 47 3 50 41
3 34 5 37 36 37 42 0 56 15 56 61 0 40 -11 49 -60 49 -26 0 -29 4 -32 38 -3
36 -5 37 -43 40 -23 2 -44 0 -48 -4z m75 -51 c3 -37 4 -38 46 -41 41 -3 42 -4
42 -37 0 -33 -1 -34 -42 -37 -43 -3 -43 -3 -46 -46 -3 -42 -4 -43 -35 -40 -30
3 -32 6 -35 45 -3 42 -3 42 -45 45 -39 3 -42 5 -42 33 0 28 3 30 43 33 42 3
42 3 42 43 0 38 1 39 34 39 33 0 35 -2 38 -37z"
      />
      <path
        d="M133 1117 l-21 -23 24 -23 24 -23 24 23 24 23 -21 23 c-12 12 -24 23
-27 23 -3 0 -15 -11 -27 -23z"
      />
      <path
        d="M331 1067 c-14 -6 -26 -17 -28 -23 -5 -16 45 -36 107 -43 55 -6 71
-23 27 -29 -21 -3 -92 18 -149 42 -13 6 -22 -1 -38 -26 -44 -73 -11 -182 71
-226 112 -60 241 20 241 148 0 98 -72 170 -170 170 -20 0 -48 -6 -61 -13z
m147 -27 c35 -22 71 -87 72 -130 0 -43 -42 -112 -80 -132 -100 -52 -220 17
-220 129 0 55 18 96 39 87 83 -36 185 -47 194 -21 10 28 -13 47 -58 47 -57 0
-105 17 -85 30 27 17 103 11 138 -10z"
      />
      <path
        d="M660 745 c0 -8 -7 -15 -15 -15 -21 0 -18 -11 9 -38 l24 -23 25 24 25
23 -25 22 c-29 26 -43 28 -43 7z"
      />
      <path
        d="M245 699 c-54 -27 -102 -75 -133 -134 -26 -48 -27 -57 -30 -232 l-4
-182 27 -27 c20 -20 32 -24 53 -19 15 3 32 11 37 16 6 6 12 81 15 167 7 233
24 197 28 -58 l2 -210 150 0 150 0 0 208 c0 115 3 211 6 215 3 3 19 -20 36
-51 16 -31 37 -65 47 -75 17 -17 19 -17 68 15 27 18 58 38 68 44 17 9 15 12
-16 30 -23 14 -48 46 -78 100 -52 95 -105 164 -147 193 -47 33 -38 50 -89
-174 -16 -66 -31 -124 -36 -129 -8 -9 -16 17 -49 159 -43 186 -37 178 -105
144z m89 -151 c20 -84 40 -159 45 -167 22 -35 40 1 76 153 20 86 42 156 48
156 22 0 94 -90 147 -184 32 -56 65 -103 79 -111 l25 -12 -22 -7 c-12 -4 -35
-19 -52 -32 -16 -14 -33 -23 -38 -20 -5 3 -24 35 -42 71 -23 45 -38 65 -49 63
-14 -3 -16 -31 -19 -211 l-2 -207 -140 0 -140 0 -2 208 c-3 199 -4 207 -23
207 -19 0 -20 -8 -25 -151 -5 -157 -13 -184 -51 -184 -9 0 -25 7 -34 16 -14
14 -16 41 -13 198 3 204 10 228 81 299 33 33 86 65 109 67 3 0 22 -69 42 -152z"
      />
      <path
        d="M344 705 c-7 -17 40 -206 51 -206 9 0 54 158 55 193 0 12 -12 17 -51
20 -29 2 -53 -1 -55 -7z m86 -17 c0 -7 -8 -44 -17 -83 l-17 -70 -18 70 c-24
94 -24 95 17 95 21 0 35 -5 35 -12z"
      />
      <path
        d="M834 666 c-37 -16 -69 -55 -84 -101 -28 -84 50 -185 142 -185 156 0
205 217 64 281 -48 22 -80 23 -122 5z m123 -26 c64 -39 85 -115 48 -177 -52
-88 -192 -81 -231 12 -19 46 -18 73 4 114 35 65 118 89 179 51z"
      />
      <path
        d="M730 328 c-79 -48 -110 -111 -110 -224 l0 -84 276 0 276 0 -4 93 c-3
78 -8 100 -30 138 -38 65 -99 105 -155 101 -76 -5 -137 -4 -168 2 -24 6 -42 0
-85 -26z m160 0 c19 0 58 2 87 4 45 3 56 -1 90 -28 58 -46 83 -103 83 -191 l0
-73 -257 0 -258 0 5 82 c6 87 21 127 62 164 43 40 81 55 118 48 19 -4 51 -7
70 -6z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconAcompanhamento',
}
</script>

<style></style>
